import { useState, useEffect, useCallback, useMemo } from "react";
import { useBluelagoon } from "@bluelagoon";

export default function useResourceMention() {
    const [resources, setResources] = useState([]);
    const [isLoaded, setIsLoaded] = useState(false);
    const { call: fetchResources } = useBluelagoon({ method: "getSupportResources" });

    useEffect(() => {
        fetchResources().then((res) => {
            if (res?.data) {
                const flat = [
                    ...(res.data.docs || []).map((d) => ({ id: d.id, title: d.title, type: "doc", url: d.url })),
                    ...(res.data.videos || []).map((v) => ({ id: v.id, title: v.title, type: "video", url: v.url })),
                ];
                setResources(flat);
                setIsLoaded(true);
            }
        }).catch(() => {});
    }, [fetchResources]);

    const search = useCallback((term) => {
        if (!term) return resources.slice(0, 15);
        const q = term.toLowerCase();
        return resources.filter((r) => r.title.toLowerCase().includes(q)).slice(0, 15);
    }, [resources]);

    return useMemo(() => ({ resources, search, isLoaded }), [resources, search, isLoaded]);
}
